<section class="gestion-placeholder" [attr.data-feature]="feature">
  <div class="gp-card">
    <div class="gp-icon" aria-hidden="true">
      <i
        class="fas"
        [class.fa-clipboard-list]="feature === 'estado-tramite'"
        [class.fa-file-invoice]="feature === 'factura'"
        [class.fa-ban]="feature === 'revocar'"></i>
    </div>
    <div class="gp-copy">
      <div class="gp-badges">
        <span class="gp-badge">Próximamente</span>
        <span class="gp-badge gp-diff" [ngClass]="difficultyClass">
          Dificultad {{ meta.difficulty }}
        </span>
      </div>
      <h2>{{ meta.title }}</h2>
      <p>{{ meta.lead }}</p>
      <p class="gp-note">{{ meta.difficultyNote }}</p>
      <p class="gp-canal">
        Referencia Canal: <code>{{ meta.canalPath }}</code>
      </p>
    </div>
  </div>
</section>
